import html2canvas from 'html2canvas';

export async function nodeToBase64(node: HTMLElement, filter?: (node: Node) => boolean, quality = 0.35): Promise<string> {
    const clonedNode: HTMLElement = node.cloneNode(true) as HTMLElement;
    clonedNode.style.width = `${node.offsetWidth}px`;
    clonedNode.style.height = `${node.offsetHeight}px`;
    clonedNode.style.position = 'absolute';
    clonedNode.style.left = '-9999px';

    document.body.appendChild(clonedNode);

    try {
        const canvas = await html2canvas(clonedNode, {
            logging: false,
            useCORS: true,
            scale: 1,
            imageTimeout: 0,
            ignoreElements: (element) => {
                return filter ? !filter(element) : false;
            },
        });

        return canvas.toDataURL('image/jpeg', quality);
    } finally {
        document.body.removeChild(clonedNode);
    }
}
